import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCredentials,
  saveCredentials,
  clearMessage,
} from "../reducers/credentialsSlice";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  CircularProgress,
  Alert,
} from "@mui/material";

const DialogFrame = () => {
  const dispatch = useDispatch();
  const { creds, status, error, message, deploymentType } = useSelector(
    (state) => state.s1Credentials,
  );

  const license_key = useSelector(
    (state) => state.authen.loggedInUser?.license_key,
  );

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [organization, setOrganization] = useState("");

  useEffect(() => {
    dispatch(fetchCredentials({ license_key }));
  }, [dispatch, license_key]);

  useEffect(() => {
    if (creds) {
      setUsername(creds.username || "");
      setPassword(creds.password || "");
      setOrganization(creds.organization || "");
    }
  }, [creds]);

  const handleSave = () => {
    if (!username || !password || !organization) {
      return alert("All fields are required.");
    }
    dispatch(
      saveCredentials({ license_key, username, password, organization }),
    );
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        width: 400,
        backgroundColor: "#E8E9EB",
        border: "2px solid #CCCCCC",
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", color: "#625D5D", mb: 2 }}
      >
        {creds ? "Update EMIS Credentials" : "Add EMIS Credentials"}
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {message && (
        <Alert
          severity="success"
          onClose={() => dispatch(clearMessage())}
          sx={{ mb: 2 }}
        >
          {message}
        </Alert>
      )}

      <TextField
        fullWidth
        label="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        margin="normal"
        disabled={deploymentType === "runner"}
      />

      <TextField
        fullWidth
        label="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        margin="normal"
        disabled={deploymentType === "runner"}
      />

      <TextField
        fullWidth
        label="Organization ID"
        value={organization}
        onChange={(e) => setOrganization(e.target.value)}
        margin="normal"
        disabled={deploymentType === "runner" || !!creds?.organization}
      />

      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={deploymentType === "runner" || status === "saving"}
        >
          {status === "saving" ? (
            <CircularProgress size={24} sx={{ color: "white" }} />
          ) : creds ? (
            "Update"
          ) : (
            "Save"
          )}
        </Button>
      </Box>
    </Paper>
  );
};

export default DialogFrame;
